import React from 'react';
import './TeamGrid.css';
import team from '../../assets/team.png';
import shannon from '../../assets/shannon.jpg';
import josphat from '../../assets/josphat.jpg';
import edith from '../../assets/edith.jpg';
import tim from '../../assets/tim.jpg';
import aslan from '../../assets/aslan.jpg';
import javan from '../../assets/javan.jpg';
import joylizza from '../../assets/joylizza.jpg';


const TeamGrid = () => {
  const teamMembers = [
    {
      name: 'Shannon Mujera',
      role: 'Team Lead',
      imageUrl: shannon
    },
    {
      name: 'Josphat Wanjiru',
      role: 'Community Lead',
      imageUrl:josphat
    },
    {
      name: 'Diana Wangui',
      role: 'Media Lead',
      imageUrl: edith
    },
    {
      name: 'Githaiga Timothy',
      role: 'Technical Lead',
      imageUrl: tim
    },
    {
      name: 'Joylizza Mwangi',
      role: 'Events Lead',
      imageUrl: joylizza
    },
    {
      name: 'Javan Mugambi',
      role: 'Digital Marketing Lead',
      imageUrl: javan
    },
    {
      name: 'Vacant',
      role: 'Content Lead',
      imageUrl: team
    },
    {
      name: 'Aslan Ndeto',
      role: 'Finance Lead',
      imageUrl: aslan
    },
    {
      name: 'Vacant',
      role: 'Academia Lead',
      imageUrl: team
    },
    {
      name: 'Vacant',
      role: 'Research Lead',
      imageUrl: team
    },
  ];

  return (
    <div className="team-container">
      <h1 className="team-title">Our Community Builders</h1>
      
      <div className="team-grid">
        {teamMembers.map((member) => (
          <div key={member.name} className="team-member">
            <div className="member-image-container">
              <img
                src={member.imageUrl}
                alt={member.name}
                className="member-image"
              />
            </div>
            <h3 className="member-name">{member.name}</h3>
            <p className="member-role">{member.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamGrid;